import { PipeTransform, Pipe } from '@angular/core';
import moment from 'moment';
@Pipe({
    standalone: false,
    name: 'momentDate'
})
export class MomentDatePipe implements PipeTransform {
    transform(date): string {
        return date ? moment(date).format('DD/MM/YYYY') : '';
    }
}
